
import jonathanMifsudPhoto from '../assets/images/team/jonathan-mifsud.jpg';
import jeremyMifsudPhoto from '../assets/images/team/jeremy-mifsud.jpg';
import davidSeisunPhoto from '../assets/images/team/david-seisun.jpg';
import roseBonniciPhoto from '../assets/images/team/rose-bonnici.jpg';


const teamMembers = [
  {
    name: "David Seisun",
    photo: davidSeisunPhoto,
    role: "Co-Founder & CEO",
    organisation: "Buddy",
    linkedIn: "https://www.linkedin.com/in/davidseisun/",
    bio: "David is our big guy. He gets involved when clients get big and hairy. He's constantly looking to grow Buddy both in Malta and on an international level."
  },
  {
    name: "Jonathan Mifsud",
    photo: jonathanMifsudPhoto,
    role: "Co-Founder & CTO",
    organisation: "Buddy",
    linkedIn: "https://www.linkedin.com/in/jonmifsud/",
    bio: "Jonathan and his tech team are always looking at ways to make payroll simpler, faster and error free. He set his sights on Buddy being the #1 payroll solution."
  },
  {
    name: "Jeremy Mifsud",
    photo: jeremyMifsudPhoto,
    role: "Head of Customer Experience",
    organisation: "Buddy",
    linkedIn: "https://www.linkedin.com/in/jeremy-mifsud/",
    bio: "Jeremy's #1 priority is your happiness. The customer experience team is available to help via chat and phone to ensure you have a great experience."
  }
]

export default teamMembers;